import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import bookdetails from '../Assets/yogadown.jpg'

function Service2() {
  return (
    <>
    <Navbar/>
    <div className='aboutbanner aboutbanner10'>
    <h3>Yoga</h3>
    {/* <p>Escape, Recharge & Renew</p> */}

    </div>
    <div className='about-classes'>
    <div className='about-classes-left'>
    {/* <h3>Awaken your energy, ignite your strength, and connect with your breath.</h3> */}
    <p>Yoga is more than just movement  it's a powerful practice that awakens your body, calms your mind, and restores your inner balance. Each breath grounds you, each pose strengthens you, and each session becomes a journey of self-discovery.</p>
    <p>Whether you're seeking energy, stillness, or healing, yoga at Alura offers a space where you can unwind, recharge, and reconnect with yourself.</p>
    <p>Breathe deeply, move freely, and find your center  your journey starts here</p>


    {/* <p>Expect creative flows that challenge your coordination, enhance your endurance, and leave you feeling empowered and strong. The focus is on building strength, improving flexibility, and cultivating mental clarity—all while moving in harmony with your breath.</p> */}

    
    <ul>
        <li><b>Hatha Yoga </b> A gentle practice featuring traditional poses and slow-paced stretches, perfect for beginners seeking calmness and improved flexibility.</li>
        <li><b>Vinyasa Yoga </b> A dynamic, fast-paced flow that synchronizes breath with movement, enhancing strength, energy, and mental focus.</li>
        <li><b>Power Yoga </b> A fitness-driven practice that combines yoga postures with strength-building exercises, ideal for boosting endurance and toning the body.</li>
        <li><b>Yin Yoga </b> A deeply relaxing practice with long, passive stretches designed to release tension, improve flexibility, and promote mindfulness.</li>
        <li><b>Kundalini Yoga </b> A spiritual practice that uses breathwork, meditation, and movement to awaken energy through the seven chakra centers, fostering mental clarity and emotional balance.</li>
        <li><b>Pre-Natal Yoga </b> A nurturing and gentle practice designed to support expecting mothers, enhancing comfort, strength, and emotional well-being throughout pregnancy.
       
</li>
        <li><b>        Mobility and Flexibility         </b> Mobility is active control of movement, while flexibility is the ability to stretch — both are essential for a balanced yoga practice.</li>



    </ul>

    

    
</div>
   <div className='about-classes-right'>
<img src={bookdetails}/>
 

</div>
    </div>
    <Footer/>
   </>
  )
}

export default Service2